const mapValues = require('lodash/mapValues');
const omitBy = require('lodash/omitBy');
const get = require('lodash/get');


export function ngrsEnabledAndRSLinkIsOnlyService(serviceinfo) {
    if (this.isNgrs() && serviceinfo && serviceinfo.length === 1) {
        return serviceinfo[0].type === 'AlmaResourceSharing';
    }
    return false;
}

export function isNgrs() {
    if ( window.appConfig['system-configuration'] && window.appConfig['system-configuration'].ngrs_enabled
    	&& passesNgrsImplementationModeCheck() && useRapidoDisplay()) {
        return true;
    }
    return false;
}

export function filteredServices(serviceinfo){
    let result = serviceinfo;
    if(this.isNgrs()){
        result = serviceinfo.filter((currService)=>{
            return currService.type !== 'AlmaResourceSharing'
        });
    }else{
        result = serviceinfo;
    }
    return result;
}

export function getResourceType(item){
    let resourceType = get(item, 'pnx.addata.genre[0]');
    if(!resourceType || resourceType == 'unknown'){
        resourceType = get(item, 'pnx.display.type[0]','b').toLowerCase();
		if(!resourceType || resourceType == 'unknown'){
			resourceType='unknown';
		}
    }
    return resourceType.toLowerCase();
}

export function passesNgrsImplementationModeCheck() {
    if (window.appConfig['system-configuration'] && window.appConfig['system-configuration'].ngrs_implementation_mode) {
        if(isRapidoFlagOn()) {
        	return true;
        } else {
        	return false;
        }
    }
    return true;
}

export function useRapidoDisplay() {
    if (window.appConfig['system-configuration'] && window.appConfig['system-configuration'].use_rapido_functionality) {
        return true;
    }
    return false;
}

export function isRapidoFlagOn() {
    try {
		let isRapido = window.sessionStorage.getItem("isRapido");
    	return isRapido === 'true';
    } catch (err) {
    	//safari incognito mode will throw error here
    }
    return false;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/ngrsUtil.ts